import axios from 'axios';
import { getCookie } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const getAuthHeaders = () => {
  const token = getCookie('token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
};

// Public: get approved comments for a news article
export const getNewsComments = async (newsId) => {
  const { data } = await axios.get(
    `${API_BASE_URL}/api/v1/news/${newsId}/comments`,
    { headers: getAuthHeaders() }
  );
  return data;
};

// Public: get approved comments for a blog article
export const getBlogComments = async (blogId) => {
  const { data } = await axios.get(
    `${API_BASE_URL}/api/v1/blogs/${blogId}/comments`,
    { headers: getAuthHeaders() }
  );
  return data;
};

// Public: submit a comment on a news article
export const createNewsComment = async (newsId, body, authorName = '') => {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/v1/news/${newsId}/comments`,
    { body, authorName },
    { headers: getAuthHeaders() }
  );
  return data;
};

// Public: submit a comment on a blog article
export const createBlogComment = async (blogId, body, authorName = '') => {
  const { data } = await axios.post(
    `${API_BASE_URL}/api/v1/blogs/${blogId}/comments`,
    { body, authorName },
    { headers: getAuthHeaders() }
  );
  return data;
};

// Moderation: get all comments with filters
export const getComments = async (params = {}) => {
  const { data } = await axios.get(
    `${API_BASE_URL}/api/v1/comments`,
    { params, headers: getAuthHeaders() }
  );
  return data;
};

// Moderation: update comment status (PENDING | APPROVED | HIDDEN)
export const updateCommentStatus = async (commentId, status) => {
  const { data } = await axios.patch(
    `${API_BASE_URL}/api/v1/comments/${commentId}`,
    { status },
    { headers: getAuthHeaders() }
  );
  return data;
};

// Moderation: delete comment
export const deleteComment = async (commentId) => {
  const { data } = await axios.delete(
    `${API_BASE_URL}/api/v1/comments/${commentId}`,
    { headers: getAuthHeaders() }
  );
  return data;
};

// Public: get comment settings (e.g. allowAnonymousComments)
export const getCommentSettings = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/api/v1/comment-settings`);
  return data;
};

// Moderation: update comment settings (allow/disallow anonymous comments)
export const updateCommentSettings = async (payload) => {
  const { data } = await axios.put(
    `${API_BASE_URL}/api/v1/comment-settings`,
    payload,
    { headers: getAuthHeaders() }
  );
  return data;
};

// Moderation: list news id+title for article dropdown (searchable)
export const getNewsListForModeration = async (q = '') => {
  const { data } = await axios.get(
    `${API_BASE_URL}/api/v1/news/list-for-moderation`,
    { params: { q, limit: 30 }, headers: getAuthHeaders() }
  );
  return data;
};

// Moderation: list blogs id+title for article dropdown (searchable)
export const getBlogListForModeration = async (q = '') => {
  const { data } = await axios.get(
    `${API_BASE_URL}/api/v1/blogs/list-for-moderation`,
    { params: { q, limit: 30 }, headers: getAuthHeaders() }
  );
  return data;
};
